import { render, staticRenderFns } from "./homeAseg.vue?vue&type=template&id=7e88499c&scoped=true"
import script from "./homeAseg.vue?vue&type=script&lang=js"
export * from "./homeAseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e88499c",
  null
  
)

export default component.exports